export default __webpack_public_path__ + "static/media/voicesteps.8a0b21cf.webp";